@if (initialiserer) {
  <mat-spinner class="mat-spinner"></mat-spinner>
}
@if (!initialiserer) {
  <e-boks-tilmelding [afkraevAdressekode]="true" class="mat-elevation-z2"></e-boks-tilmelding>
}
